import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import classNames from 'classnames';

interface Props {
	status: BarStatus;
}

export enum BarStatus {
	Success = 'success',
	Fail = 'fail',
	None = 'none'
}

const ContentWithStatusBar: FunctionComponent<Props> = ({ status, children }) => {
	return (
		<div className={classNames('content-with-status-bar', status)}>
			{status !== BarStatus.None && (
				<div className="icon-container">
					{status === BarStatus.Success && <FontAwesomeIcon className="icon" icon={faCheck} />}
					{status === BarStatus.Fail && <FontAwesomeIcon className="icon" icon={faTimes} />}
				</div>
			)}
			<div className="content-with-status-bar-content">{children}</div>
		</div>
	);
};

export default ContentWithStatusBar;
